<!-- 填空题 -->
<template>
  <div class="blank">
    <div class="content" v-if="info">
      <div class="title fontSize32">
        <!-- <span class="paper_blue">【{{ quesMap[info.type] }}】</span> -->
        <span>{{ no + 1 }}、</span>
        <span v-html="reformHtml(info.content)"></span>
      </div>
      <div class="txts" v-if="!readOnly">
        <div v-for="(item, index) in info.blanks" :key="index" style="display: flex;">
          <!-- <div style="width:60px;min-width:60px;">【空{{ index + 1 }}】</div> -->
          <el-input v-model="answer[index]" placeholder="请输入" @input="change($event, index)" :disabled="readOnly" />
        </div>
      </div>
      <div class="next_last">
        <el-button type="info" size="mini" @click="$emit('lastNext', 'last')" v-if="lastNext">上一题</el-button>
        <el-button type="danger" size="mini" class="ml" @click="$emit('lastNext', 'next')"
          v-if="lastNext">下一题</el-button>
        <el-button type="warning" size="mini" class="ml" @click="$emit('submit', info.id)"
          v-if="value && !readOnly && submit">提交</el-button>
      </div>
      <!-- 解析 -->
      <div class="analysisBox" :class="isOne ? '': 'noMargin bottomBorder'" v-if="readOnly">
        <div class="stjx-title" :class="isOne ? '': 'noLine noPadding'">试题解析</div>
        <div class="d-flex d-flex-middle">您的答案：
          <span v-if="value" class="cRed">
            <span v-for="(item, index) in value.split('`')" :key="index">
              【空{{ index + 1 }}】
              {{ item || "" }}；
            </span>
          </span>
        </div>
        <div>正确答案：
          <span v-for="(item, index) in info.blanks" :key="index" class="cGreed">
            【空{{ index + 1 }}】
            {{ item.value || "" }}；
          </span>
        </div>
        <div class="stjx">试题解析：<span class="cGrey" v-html="reformHtml(info.analysis||info.resolve)"></span></div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { quesMap } from "@/utils/enum.js";
export default {
  name: "blank",
  props: {
    info: {},
    readOnly: false,
    lastNext: false,
    submit: false,
    value: {
      default: "",
    },
    check: {},
    no: '',
    isOne: false,
  },
  data () {
    return {
      quesMap,
      answer: [],
    };
  },
  watch: {
    info: {
      handler: function (n, o) {
        const v = this.value.split("`");
        this.answer = n.blanks.map((e, i) => v[i] || "");
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    getMyAnswer () {
      var list = [];
      this.info.myAnswer.map((v) => {
        list.push(v.value);
      });
      return list.join("`");
    },
  },
  methods: {
    reformHtml (html) {
      if(!html){
        return html
      }
      var reg = new RegExp("\\[BlankArea\\d]", "g");
      html = html.replace(reg, "____");
      return html.replace(/<p.*?>/gi, "");
    },
    change (e, i) {
      this.$emit("input", this.answer.join("`"));
    },
  },
};
</script>

<style lang="scss">
.blank {
  padding-left: 12px;

  .paper_blue {
    color: #3677EA;
  }

  .paper_red {
    color: #FF2929;
  }

  .next_last {
    text-align: right;
    // border-bottom: 1px solid #D2D2D2;
    // padding: 50px 0;
  }

  .content {
    .title {
      margin-bottom: 15px;
      line-height: 20px;
    }

    .txts {
      input {
        width: 100%;
        border: 1px solid #e1e1e1;
        border-radius: 5px;
        height: 32px;
        line-height: 20px;
        margin-bottom: 15px;
        box-sizing: border-box;
        padding: 5px 10px;
        font-size: 14px;
      }
    }
  }
  .noMargin{
      margin:0 !important;
      .noLine {
        padding-top:10px !important;
        margin: 0;
        display: none;
      }
    }
  .analysisBox {
    box-sizing: border-box;
    padding: 5px 10px;
    margin: 50px 0 0 0;

    div {
      margin: 20px 0;
    }

    .stjx {
      display: flex;

      span {
        width: 420px;
        display: inline-block;
      }
    }

    .stjx-title {
      text-align: center;
      border-top: 1px solid #D2D2D2;
      padding-top: 30px;
      font-size: 14px;
      color: #E03019;
    }
  }
}
</style>
